import { render, staticRenderFns } from "./TableRowVialsTotal.vue?vue&type=template&id=087a99dd&lang=pug&"
import script from "./TableRowVialsTotal.vue?vue&type=script&lang=js&"
export * from "./TableRowVialsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087a99dd')) {
      api.createRecord('087a99dd', component.options)
    } else {
      api.reload('087a99dd', component.options)
    }
    module.hot.accept("./TableRowVialsTotal.vue?vue&type=template&id=087a99dd&lang=pug&", function () {
      api.rerender('087a99dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/performance-evaluation/table-rows/TableRowVialsTotal.vue"
export default component.exports